































import { Component, Vue } from "vue-property-decorator";

@Component
export default class Settings extends Vue {
  joinRoomId: string = "";
  createRoomId: string = "";
  roomSize: number | null = null;

  get message(): string {
    if (this.$store.state.co_op.joined) return `Joined room ${this.$store.state.co_op.room}`;

    const err = this.$store.state.co_op.error;
    if (err) return err;

    return "";
  }

  join(event: Event): void {
    this.$store.dispatch("co_op/join", { room: this.joinRoomId });
  }

  create(event: Event): void {
    this.$store.dispatch("co_op/create", { size: this.roomSize || 2 });
  }
}
